export enum PulseDeployStage {
  Dev = 'dev',
  Pre = 'pre',
  Pro = 'pro',
}
